@if (isLoading()) {
  <app-loading-skeleton class="h-5 w-20" viewBox="0 0 80 20">
    <svg:rect x="0" y="0" rx="3" ry="3" width="80" height="20" />
  </app-loading-skeleton>
} @else if (presentation(); as value) {
  <span
    class="whitespace-pre-line"
    [appPopover]="displayTimezones() ? ('shared.site-date-time.time-zone' | translate: { timeZone: value.timeZoneLabel }) : ''"
  >
    {{ value.formattedValue }}
  </span>
} @else {
  <span></span>
}
